const BULK_UPLOADER_TITLE = {
  PO: 'New Bulk PO Creation Request',
  'po-allocation': 'New Bulk PO Allocation Request',
  'so-appointment': ' New Bulk SO Appointment Request',
  'so-dispatch': 'New Bulk SO Dispatch Request',
  'so-deliver': 'New Bulk SO Deliver Request',
  trustbasket: 'New Bulk ReOrder Request',
  SKUTP: 'Transfer Pricing',
  COGS: 'COGS',
  'eo-dispatch': 'Bulk Dispatch International Orders',
  'eo-deliver': 'Bulk Deliver International Orders'
};

export default BULK_UPLOADER_TITLE;
